import React from 'react';

import { withPrefix } from 'gatsby';
import styled from 'styled-components';

import ContentContainer from 'components/ContentContainer/ContentContainer';
import Link from 'components/Link';
import SearchBar from 'components/SearchBar';

import { HelpCardsI, HelpCategoriesI } from 'interfaces/content-stack/modular-blocks/helpCards';

import { buildBreadcrumbUrls } from 'utils/functions';

const HelpCard = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.whiteSmoke};
`;

const CardsContainer = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const CardHeader = styled.h3`
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.4;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
    font-size: 1.15rem;
  }
`;

const Grid = styled.div`
  grid-gap: 2rem;
`;

const Title = styled(Link)`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primaryRed};
  }
`;

const InnerCardContent = styled.div`
  grid-column-gap: 0.5rem;
  grid-row-gap: 0.5rem;
  flex-flow: column;
  display: flex;
`;

const CardContainer = styled.div`
  padding: 2rem;

  @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
    padding: 1rem;
  }
`;

export interface HelpCardsProps {
  data: { helpCards: HelpCardsI[] };
  helpCategories: HelpCategoriesI[];
}

const HelpCards = ({ data }: HelpCardsProps) => {
  return (
    <ContentContainer innerPaddingOverride={'0rem'} zIndex={'10'}>
      <SearchBar searchUrl={withPrefix('/help-center-search/')} placeholder={'Search the help center...'} suggestions />
      <CardsContainer>
        {data.helpCards.map((card) => (
          <HelpCard key={card.header}>
            <Grid>
              <CardContainer>
                <CardHeader>{card.header}</CardHeader>
                <InnerCardContent>
                  {card.helpCategories.map((category) => {
                    const { breadcrumb, title, url } = category;

                    return (
                      <Title key={title} to={buildBreadcrumbUrls(breadcrumb, url)}>
                        {title}
                      </Title>
                    );
                  })}
                </InnerCardContent>
              </CardContainer>
            </Grid>
          </HelpCard>
        ))}
      </CardsContainer>
    </ContentContainer>
  );
};

export default HelpCards;
